const items = [
  {
    title: '韩漫爆款：霸道总裁系列合集',
    desc: '精选布丁漫画网最受欢迎的霸道总裁题材韩漫全集，从契约婚姻到甜蜜反转，下拉式连续阅读让你一口气追完。',
    img: 'https://readdy.ai/api/search-image?query=A%20romantic%20digital%20illustration%20of%20a%20couple%20in%20elegant%20attire%20standing%20in%20a%20luxurious%20modern%20office%20setting%2C%20Korean%20manhwa%20art%20style%2C%20warm%20coral%20and%20peach%20color%20palette%2C%20soft%20romantic%20atmosphere%2C%20clean%20vector%20illustration%20with%20decorative%20sparkles&width=600&height=400&seq=carousel-01&orientation=landscape',
    tag: '韩漫精选',
  },
  {
    title: '日漫经典：剑与魔法的世界',
    desc: '布丁漫画网日漫频道精选奇幻冒险类全集，从异世界转生到魔法学院，支持布丁漫画连续阅读模式畅读。',
    img: 'https://readdy.ai/api/search-image?query=A%20fantasy%20digital%20illustration%20of%20a%20magical%20world%20with%20castles%20and%20floating%20islands%2C%20Japanese%20manga%20inspired%20art%20style%2C%20warm%20amber%20and%20golden%20color%20palette%2C%20adventurous%20atmosphere%2C%20clean%20flat%20vector%20illustration%20with%20magical%20effects&width=600&height=400&seq=carousel-02&orientation=landscape',
    tag: '日漫经典',
  },
  {
    title: '国漫崛起：修仙大佬在都市',
    desc: '布丁漫画网国漫频道头部作品，修仙与现代都市的精彩碰撞。布丁漫画下拉式免费看全集，每日更新不停。',
    img: 'https://readdy.ai/api/search-image?query=A%20dynamic%20illustration%20of%20a%20cultivator%20in%20modern%20city%20setting%20with%20flowing%20robes%20and%20energy%20effects%2C%20Chinese%20manhua%20art%20style%2C%20warm%20orange%20and%20golden%20color%20palette%2C%20dramatic%20composition%2C%20clean%20vector%20illustration%20with%20urban%20backdrop&width=600&height=400&seq=carousel-03&orientation=landscape',
    tag: '国漫精选',
  },
  {
    title: '甜宠恋爱：甜蜜的陷阱全集',
    desc: '布丁漫画网甜宠悬疑题材韩漫推荐，反转不断的剧情让人欲罢不能。全集支持布丁漫画连续阅读，一口气看到结局。',
    img: 'https://readdy.ai/api/search-image?query=A%20sweet%20and%20mysterious%20digital%20illustration%20of%20a%20couple%20in%20a%20cozy%20cafe%20setting%20with%20suspenseful%20lighting%2C%20Korean%20webtoon%20art%20style%2C%20warm%20peach%20and%20rose%20color%20palette%2C%20romantic%20yet%20intriguing%20atmosphere%2C%20clean%20flat%20vector%20illustration&width=600&height=400&seq=carousel-04&orientation=landscape',
    tag: '甜宠推荐',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            编辑精选
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
            精选专题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            布丁漫画网编辑团队为你精选的热门专题合集
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 border border-background-200/70 rounded-2xl overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-default"
            >
              <div className="w-full aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}